import React from "react";

import "./styles/shape.css";

export const Shape: React.FC = () => {
  return <div className="h__shape"></div>;
};
